var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCocktailAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.983 2H4.01696C3.15639 2 2.68628 3.00077 3.2372 3.65994L5.33375 6.16845L6.00748 6.00051C7.95884 5.5141 10.0143 5.65319 11.8819 6.39803C13.331 6.976 14.9175 7.12124 16.448 6.81603L18.4604 6.41473L20.7628 3.65995C21.3137 3.00077 20.8436 2 19.983 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2388 13.2337L6.41614 7.46354C8.04525 7.06614 9.75858 7.18621 11.3164 7.80752C13.0398 8.49487 14.9265 8.66758 16.7466 8.30462L16.9077 8.2725L12.7613 13.2337V20.4819H15.0451C15.4655 20.4819 15.8063 20.8218 15.8063 21.241C15.8063 21.6602 15.4655 22 15.0451 22H8.95496C8.53453 22 8.1937 21.6602 8.1937 21.241C8.1937 20.8218 8.53453 20.4819 8.95496 20.4819H11.2388V13.2337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktailAlt1);
export default __webpack_public_path__ + "static/media/cocktail-alt-1.087b4800798375363d1501985ede79b2.svg";
export { ForwardRef as ReactComponent };